import { createContext } from 'react';

import { SortField } from '@totem/components/ui_components/reportSettings/types';
import {
  Paging,
  PersistentData,
  PersistentDataItems,
  PersistentFilterFields,
} from '@totem/components/userContext/persistence/types';

export interface Context {
  persistenceData: PersistentDataItems;
  persistenceLoaded: boolean;
  // The organizationId the currently loaded persistenceData was fetched for.
  // Consumers that react to an organization switch must confirm this matches
  // the user's current organization before trusting persistenceLoaded — the
  // flag can otherwise be (stale-)true for one render while a reload is still
  // in flight, since effects in child components can fire before this
  // provider's own reload effect has a chance to reset it.
  persistenceOrganizationId: string;
  getComponentPersistence: (componentKey: string) => PersistentData | null;
  updateComponentPersistence: (
    componentKey: string,
    label: string,
    paging: Paging,
    sort: SortField,
    filters: PersistentFilterFields,
  ) => void;
  deleteComponentPersistence: (componentKey: string) => void;
}

export const initialPersistenceState: Context = {
  persistenceData: [],
  persistenceLoaded: false,
  persistenceOrganizationId: '',
  getComponentPersistence: () => null,
  updateComponentPersistence: () => {},
  deleteComponentPersistence: () => {},
};

const persistenceContext = createContext<Context>(initialPersistenceState);

export default persistenceContext;
